import * as React from "react";
import styled from "@emotion/styled";
import Button from "@/components/atoms/Button";
import breakpoint from "@/utils/breakpoint";

const ButtonBody = styled(Button)`
  height: 60px;
  background: #ffffff00;
  box-shadow: 0px -4px 0px #e0e0e0 inset;
  border: 2px solid #313131;
  border-radius: 4px;
  text-align: center;
  font-size: 18px;
  font-weight: bold;
  line-height: 35px;
  letter-spacing: 0px;
  color: #333333;
  opacity: 1;
  margin: 0 10px;
  margin-bottom: 10px;
  flex: 270px;

  ${breakpoint.lessThan("sm")`
    width: 100%;
    margin: 0;
    margin-bottom: 10px;
    font-size: 16px;
    font-weight: bold;
    line-height: 26px;
    flex: none;
  `}
`;

const IconContainer = styled.span`
  margin-right: 5px;
`;

const Content = styled.p`
  margin: 0;
  white-space: nowrap;
  text-align: center;
`;

type PrevButtonProps = {
  value: string;
  onClick: (ev: any) => void;
  icon?: JSX.Element;
};

const PrevButton = ({ value, onClick, icon }: PrevButtonProps) => (
  <ButtonBody onClick={onClick}>
    <Content>
      <IconContainer>
        {icon}
        &nbsp;
      </IconContainer>
      {value}
    </Content>
  </ButtonBody>
);

export default PrevButton;
